module.exports = __webpack_public_path__ + "static/media/irctc.71af279a.png";